import "./ManualsPage.scss";

import React from "react";

import { Grid2 } from "@mui/material";

import AlertComponent from "../../shared/components/alert-component/AlertComponent";
import Carousel from "../../shared/components/carousel/Carousel";
import UserPathCard from "../../shared/components/user-path-card/UserPathCard";
import {
  ContentCardData,
  FeatureToggle,
  PhManuals
} from "../../shared/models/app-data-model";

export type ManualsPageProps = {
  content: PhManuals;
  featureToggles: FeatureToggle[];
  latestPhNews?: ContentCardData[];
};

const ManualsPage: React.FC<ManualsPageProps> = (props: ManualsPageProps) => {
  const pageAlert = props.content.page_alert;
  const pageAlertData = pageAlert && pageAlert.map((alert, index) =>
    alert.alert_reference.length > 0 ? <AlertComponent message={alert.alert_reference[0]?.alert_message} severityLevel={alert.alert_reference[0]?.alert_type} button={alert.alert_reference[0]?.button} key={index}></AlertComponent> : null);
  const top_user_path_group = props.content.top_user_path_group;
  const topUserpathGroupData = top_user_path_group?.map((card, index) => (
    <UserPathCard user_path_card={card} key={index}></UserPathCard>
  ));

  const link_card_group = props.content.link_card_group;
  const linkCardGroupData = link_card_group?.map((card, index) => (
    <UserPathCard user_path_card={card} key={index}></UserPathCard>
  ));

  const news_group = props.latestPhNews && <Carousel contentCardGroup={props.latestPhNews}
    carouselTitle="Latest news" navTitle="See all news"></Carousel>;


  return (<>
    <Grid2 container rowSpacing={2} columnSpacing={3} className='manuals-page' maxWidth="xl">
      <div className="carousel-section">{news_group}</div>
      <Grid2 container className="page-alert">
        {pageAlertData}
      </Grid2>
      <Grid2 size='auto' container component="main" className="content-wrapper">
        <Grid2 size={{ xs: 12 }} container className='base-upg upg-group'>{topUserpathGroupData}</Grid2>
        <hr />
        <Grid2 size={{ xs: 12 }} container className='small-upg upg-group'>{linkCardGroupData}</Grid2>
      </Grid2>
    </Grid2>
  </>
  );
};

export default ManualsPage;